import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="fses"
export default class extends Controller {
  connect() {
    this.gridApi = window.agGrids.find((gridApi) => gridApi.name === "fses")
  }

  filter(event) {
    let filter = event.currentTarget.dataset.filter
    this.setFilter(filter)
  }

  setFilter(filter) {
    let rowData = []
    this.gridApi.forEachNode(node => rowData.push(node.data))
    let allFacilities = rowData.map(row => row["facility"])
    let uniqueFacilities = [...new Set(allFacilities)]
    let facilityName = uniqueFacilities.find(function (element) {
      if (element) { return element.includes(filter) }
    })

    let model = {
      facility: {
        type: "set",
        values: [facilityName]
      }
    }

    this.gridApi.setFilterModel(model)
  }
}
